import styled from 'styled-components';

export const SpinnerMatchingStyled = styled.div`
  display: block;
  width: 8.125rem;
  height: 8.125rem;

  svg {
    path {
      stroke: #00AAE7;
    }
    transition-property: transform;
    animation-name: rotate; 
    animation-duration: 1.2s; 
    animation-iteration-count: infinite;
    animation-timing-function: linear;

    @keyframes rotate {
        from {transform: rotate(0deg);}
        to {transform: rotate(360deg);}
    }
  }
`;
